/* Open everything before the page prints, and put it back after.
 *
 * `styles/print.css` opens the folds, because a fold's body is hidden with an
 * attribute CSS can override. A `<details>` is not: a closed one renders its
 * summary and nothing else in every engine, and no stylesheet opens it. So the
 * moment before printing, every closed details on the page is opened and
 * remembered, and the moment after, those and only those are closed again. A
 * details the parent had opened themselves is left exactly as they had it.
 *
 * `SourceCredit` did this for its own details since 4 September; this is the
 * same idea for the whole document, so a tutor gets the reading review, the
 * worked answers and the licence line without anyone tapping. */
let opened: HTMLDetailsElement[] = [];

window.addEventListener("beforeprint", () => {
  // `SourceCredit` opens and closes its own details on these same events,
  // and reads its state at `beforeprint`. Opening it here first made it
  // believe it had been open all along, and it stayed open after the print.
  // A details that manages itself is left to itself.
  opened = Array.from(document.querySelectorAll<HTMLDetailsElement>("details:not([open])"))
    .filter((el) => !el.closest(".source-credit"));
  for (const el of opened) el.open = true;
});

window.addEventListener("afterprint", () => {
  for (const el of opened) el.open = false;
  opened = [];
});

export {};
